import {
  Create,
  NumberInput,
  ReferenceInput,
  SimpleForm,
  TextInput,
  required
} from "react-admin";
import { Grid } from '@mui/material';

export const BedroomCreate = () => (
  <Create>
    <SimpleForm>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ReferenceInput source="hotel_id" reference="hotel" validate={required()}/>
        </Grid>
        <Grid item xs={12}>
          <TextInput source="title" fullWidth label="Nom" validate={required()}/>
        </Grid>
        <Grid item xs={12}>
          <NumberInput source="capacity" fullWidth label="Capacité" validate={required()}/>
        </Grid>
        <Grid item xs={12}>
          <NumberInput source="base_rate" fullWidth validate={required()}/>
        </Grid>
        <Grid item xs={12}>
          <TextInput source="mews_id" fullWidth validate={required()}/>
        </Grid>
        
      </Grid>
    </SimpleForm>
  </Create>
);
